import { DatabaseModel, Media, PageMeta } from '../../models';

export class BlogPost extends DatabaseModel implements PageMeta {
    public key: string;
    public type: 'PAGE' | 'POST' | 'CUSTOM' = 'CUSTOM';
    public title: string = 'Blog Title';
    public headline: string = 'Blog Headline';
    public description: string = 'Description';
    public user: string = '';
    public userName: string = '';
    public createdOn: number | any = '';
    public keywords: string = '';
    public image: Media = null;
    public content?: string;
    public mediaMap?: { [key: string]: Media };
    public published = false;
    public language: string;
    public originKey: string = '';

    constructor(json: any) {
        super();
        if(!json) return;
        this.fromJson(json);
        return this;
    }

    public fromJson(json): BlogPost {
        Object.assign(this, json);
        this.image = new Media(json.image || {});
        this.mediaMap = this.fromJsonMap(json.mediaMap, Media);
        return this;
    }

    public toJson(): { [prop: string]: any } {
        let json = Object.assign({}, this);
        json.image = this.image ? this.image.toJson() : null;
        json.mediaMap = this.toJsonMap(this.mediaMap);
        return json;
    }
}
